<template>
	<inertia-head title="Power Talks" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Power Talks</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Get ready to unlock your potential and take control of your life! With Power Talks, you'll gain the knowledge and skills you need to reach the next level in your personal and financial life. Our comprehensive video series will give you the insights and ideas to build wealth, increase confidence, and skyrocket success. Take control of your life today with Power Talks!
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div v-if="featured" class="content mt-5">
		<div class="row">
			<div class="col-lg-8">
				<div class="block">
					<div class="block-content block-content-full p-0">
						<div style="padding: 56.25% 0 0 0; position: relative">
							<iframe
								:src="featured.video_id"
								style="
									position: absolute;
									top: 0;
									left: 0;
									width: 100%;
									height: 100%;
								"
								frameborder="0"
								allow="autoplay; fullscreen; picture-in-picture"
								allowfullscreen
							></iframe>
						</div>
					</div>
					<div class="block-content text-center border-bottom">
						<h6 class="mb-1">
							{{
								`${featured.series}.${featured.video} - ` + featured.video_title
							}}
						</h6>
						<p class="text-muted">
							{{ `${featured.series_num}: "${featured.series_title}"` }}
						</p>
					</div>
					<div v-if="featured.description" class="block-content">
						<p class="text-muted fs-sm">{{ featured.description }}</p>
					</div>
				</div>
			</div>
			<div class="col-lg-4">
				<div class="block">
					<div class="block-header border-bottom">
						<h3 class="block-title">Up Next</h3>
					</div>
					<div class="block-content block-content-full px-0">
						<div class="table-responsive">
							<table class="table table-hover table-borderless m-0">
								<tbody>
									<tr v-if="series && series.length > 0"
										v-for="next in series"
									>
										<td>
											<InertiaLink
												:key="next.counter"
												:href="
													route('member.trc-live.vault', {
														series: next.series,
														video: next.video,
													})
												"
												:only="['featured', 'series','prevSeries']"
												class="d-flex align-items-center justify-content-between mb-4"
											>
												<img
													:src="next.img_thumb_url"
													class="img-fluid img-thumbnail w-25"
													alt=""
												/>
												<div class="ms-1">
													<p class="fs-sm fw-semibold mb-0 text-dark">
														<small>{{
															`${next.series}.${next.video}: ${next.video_title}`
														}}</small>
													</p>
													<small class="text-muted fs-xs">{{ next.speaker }}</small>
												</div>
											</InertiaLink>
										</td>
									</tr>
									<tr v-else>
										<td class="text-center">
											<p class="mb-0 fw-semibold text-danger">NOTHING NEXT</p>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>

				<div v-if="prevSeries && prevSeries.length > 0" class="block">
					<div class="block-header border-bottom">
						<h3 class="block-title">Previous</h3>
					</div>
					<div class="block-content block-content-full px-0">
						<div class="table-responsive">
							<table class="table table-hover table-borderless m-0">
								<tbody>
									<tr v-for="next in prevSeries">
										<td>
											<InertiaLink
												:key="next.counter"
												:href="
													route('member.trc-live.vault', {
														series: next.series,
														video: next.video,
													})
												"
												:only="['featured', 'series','prevSeries']"
												class="d-flex align-items-center justify-content-between mb-4"
											>
												<img
													:src="next.img_thumb_url"
													class="img-fluid img-thumbnail w-25"
													alt=""
												/>
												<div class="ms-1">
													<p class="fs-sm fw-semibold mb-0 text-dark">
														<small>{{
															`${next.series}.${next.video}: ${next.video_title}`
														}}</small>
													</p>
													<small class="text-muted fs-xs">{{ next.speaker }}</small>
												</div>
											</InertiaLink>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>

			</div>
		</div>
	</div>
	<div v-else class="content mt-5">
		<div v-if="talks" class="row">
			<div v-for="(talk,t_index) in talks" :key="talk.counter" class="col-md-4 mb-4">
				<div class="block block-link-pop d-flex flex-column h-100 mb-0">
					<div class="bg-primary">
						<div
							class="block-content block-content-full bg-image flex-grow-0"
							:class="['bg-op-primary','bg-op-success','bg-op-warning','bg-op-info','bg-op-danger'][Math.floor(Math.random() * 5)]"
							style="
								height: 180px;
								background-size: cover;
								background-blend-mode:color-burn;
							"
							:style="'background-image:url('+talk.img_thumb_url+')'"
						>
							<span class="badge bg-black-50 fw-bold p-2 text-uppercase">
								{{ talk.series_num }}
							</span>
						</div>
					</div>
					<div class="block-content block-content-full flex-grow-1 text-center">
						<h6 class="m4-2">
							{{ talk.series_title }}
						</h6>
						<InertiaLink
							:href="
								route('member.trc-live.vault', {
									series: talk.series,
									video: talk.video,
								})
							"
							:only="['featured', 'series']"
							class="btn btn-alt-primary btn-sm"
						>
							Watch Series
							<i class="fa fa-arrow-right ms-1"></i>
						</InertiaLink>
					</div>
				</div>
			</div>
		</div>
		<div v-else class="alert alert-warning">
			<p class="mb-0 fw-semibold">NO POWER TALK FOUND.</p>
		</div>
	</div>
</template>

<script>

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

import { onMounted } from 'vue'
import AuthLayout from '../../../Layouts/AuthLayout'

export default {
	layout: AuthLayout,
	props: {
		talks 		: Object,
		featured 	: Object,
		series 		: Object,
		prevSeries 	: Object,
	},
	setup() {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})
	},
}
</script>
